<template>
  <div class="companyIntroduction">
    <div class="head">
      <H3>{{title}}</H3>
    </div>
    <div class="companyInfo">
      <p>
        公司定位致力于中国体育彩票实体店的信息化服务工作和责任彩票宣传工作，为体彩业主打造全套互联网营销的产品，帮助传统营销模式的业主拥抱互联网，有效扩大彩店客户群体，提高彩店日常工作效率，同时为彩票中心精细化管理网点提供技术支持。让更多的业主宣传责任彩票，让更多的彩友理解彩票的公益属性，让更多的人了解彩票，是公司发展的目标。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'companyIntroduction',
  data () {
    return {
      title: '公司简介',
      companyInfo: ''
    }
  }
}
</script>

<style scoped lang="less">
  .companyIntroduction{
    .head{
      height: 90px;
      border-bottom: 1px solid #dedede;
      h3{
        font-size: 24px;
        font-weight: bold;
        line-height: 90px;
        padding-left: 20px;
        color: #5E5E5E;
      }
    }
    .companyInfo{
      padding: 50px;
      font-size: 24px;
      line-height: 30px;
      text-indent: 48px;
      p{
        margin-bottom: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/companyIntroduction.vue